// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","PlusBadge":"bcr_a bhe_rh bhe_ri bhe_vf bhe_ec bhe_vc bhe_gq bhe_kf"};